<script>
	import { onMount, createEventDispatcher } from 'svelte';

	import { fly } from 'svelte/transition';
	import { cubicOut } from 'svelte/easing';

	import Icons from '../components/icons.svelte';

	// import SoundBox from 'sound-box';

	// import { STATUSES, TEAMS, ACTIONS } from '../utils/constants';

	const dispatch = createEventDispatcher();

	// const soundBox = new SoundBox();

	export let team;
	export let isSelected;
	export let isSelectable;
	export let isInteresting;
	export let isProcessingGuess;
	export let isCorrectGuess;
	export let isGuessedThisTurn;
	export let isAuthTeam;
	export let selectedByPlayers;
	export let word;
	export let position;
	export let clue;
	export let hasEnoughVotesToGuess;

	export let showGuessButton;
	export let highlightOwn;
	// export let forceStopAudio;

	export let GUESS = 'guess';
	export let TOGGLE_CARD = 'toggleCard';

	// on ios safari using preventDefault works to disable the click event to avoid double handling the event, but that breaks :focus, :hover on chrome android, so we do this
	let isTouch;
	let delayShowingGuessButton;

	onMount(() => {
		isTouch = 'ontouchstart' in document;
	});

	function handleClick() {
		if (isTouch) {
			return;
		}
		handleTouch();
	}
	function handleTouch() {
		if (!isSelectable) {
			return;
		}
		delayShowingGuessButton = true;
		dispatch(TOGGLE_CARD, { word, position });
		setTimeout(() => delayShowingGuessButton = false, 500);
	}



	/*
	soundBox.load('note01', '/sounds/uke/no-nosurprises-06.mp3').then();
	soundBox.load('note02', '/sounds/uke/no-nosurprises-02.mp3').then();
	soundBox.load('note03', '/sounds/uke/no-nosurprises-03.mp3').then();
	soundBox.load('note04', '/sounds/uke/no-nosurprises-05.mp3').then();

	$: if (forceStopAudio) {
		soundBox && soundBox.stop_all();
	}

	function playSound(team) {
		if (!forceStopAudio ) {
			switch (team) {
				case TEAMS.one:
					soundBox.play('note01', null, 0.5);
					break;
				case TEAMS.two:
					soundBox.play('note02', null, 0.5);
					break;
				case TEAMS.neutral:
					soundBox.play('note03', null, 0.5);
					break;
				case TEAMS.assasin:
					soundBox.play('note04', null, 0.5);
					break;
			}
		}
	}
	*/
</script>

<div
	class={`card-slot ${team}`}
	class:selected={isSelected}
	class:selectable={isSelectable}
	class:auth-team={isInteresting}
	class:flipped={!isProcessingGuess && (isCorrectGuess === true || isCorrectGuess === false)}
	class:isGuessedThisTurn={isGuessedThisTurn}
	class:dim={highlightOwn && !isInteresting}
	class:flip-forward={highlightOwn}
	tabindex="0"
	on:click|stopPropagation={handleClick}
	on:touchstart|stopPropagation={handleTouch}
>
	<div class="selected-by">
		{#if isCorrectGuess === null}
			{#each (selectedByPlayers || []) as p (p.id)}
				<span class="selected-by-player player-team-{p.team}" title={p.name}>{p.name.slice(0,1)}</span>
			{/each}
		{/if}
	</div>

	<div class="anim-layer">
	<div
		class="card"
		transition:fly="{{ x: (Math.random() - 0.5) * 500, y: (Math.random() - 0.5) * 500, duration: 1000, easing: cubicOut }}"
	>

		<div class="card-front" class:colorcycle={isProcessingGuess}>
			<span class="word"><span class="textFitted">{word}</span></span>
			{#if showGuessButton && hasEnoughVotesToGuess && !isProcessingGuess && !delayShowingGuessButton}
				<button
					class={`guess-button ${isSelected ? 'force-show' : ''}`}
					on:click|preventDefault={(e) => dispatch(GUESS, { word })}
					on:touchstart|preventDefault={(e) => dispatch(GUESS, { word })}
				>
					Guess!
				</button>
			{/if}

			{#if clue}
				<div class="clue" title="clue">
					<span class="clue-text">{clue.clueText}</span>
					<span class="clue-number">{clue.clueNumber}</span>
				</div>
			{/if}
		</div>

		<div class="card-back" class:colorcycle={isProcessingGuess}>
			{#if !isProcessingGuess && isCorrectGuess === true}
				<Icons name="checkmark" strokeWidth="0.1em" />
			{:else if !isProcessingGuess && isCorrectGuess === false}
				<Icons name="x" strokeWidth="0.1em" />
			{/if}
		</div>
	</div>
	</div>
</div>

<style lang="less">
	@import "../variables.less";

	.card-slot {
		width: 100%; height: 100%;
		top: 0; left: 0;
		font-size: 1.5em;
		font-weight: 700;
		outline: 0;
		transition: all 150ms, opacity 750ms;
		transition-delay: 0;
		perspective: 1000px;
		cursor: not-allowed;
		opacity: 1;

		&:hover {
			// top: -0.5em; left: -0.55em;
			// width: 117%; height: 117%;
			// font-size: 2em;
			transform: scale(1.18,1.18);
			z-index: 1;
		}

		&.selectable {
			cursor: default;

			&:hover {
				.card {
					.card-front, .card-back {
						border: 0.2em solid rgba(255,255,255,0.9);
						box-shadow: 0 0 0.5em rgba(255,255,255,0.9);
					}
				}
			}
		}

		.anim-layer {
			width: 100%; height: 100%;
		}

		&:not(.auth-team) {
			.anim-layer {
				animation: fade-in ease-out 8s forwards;
				@keyframes fade-in {
					0% {
						opacity: 0.2;
					}
					90% {
						opacity: 0.2;
					}
					100% {
						opacity: 1;
					}
				}
			}
		}

		&.dim {
			opacity: 0.3;
		}

		&.selected {
			.card {
				.card-front, .card-back {
					border: 0.2em solid fade(#ffff00, 100%) !important;
					box-shadow: 0 0 0.9em #ffff00 !important;
				}
			}
		}

		&.flipped {
			cursor: default;
			.card {
				transform: rotateY(180deg);
			}
			&:focus {
				.card {
					transform: rotateY(0deg);
				}
			}
		}

		&.flip-forward {
			.card {
				transform: rotateY(0deg) !important;
			}
		}

		&.isGuessedThisTurn {
			.card {
				.card-front, .card-back {
					border: 0.2em solid white;
				}
			}
		}

		&.one {
			.card {
				.card-front, .card-back {
					background-color: rgba(30,130,255,1);
				}
			}
		}
		&.two {
			.card {
				.card-front, .card-back {
					background-color: rgba(255,0,204,1);
				}
			}

		}
		&.assasin {
			.card {
				.card-front, .card-back {
					background-color: rgba(20, 20, 20,1);
				}
			}
		}
		&.neutral {
			.card {
				.card-front, .card-back {
					background-color: rgba(220,220,225,1);
				}
			}
		}

		.card {
			width: 100%; height: 100%;
			text-align: center;
			color: white;
			text-transform: uppercase;
			user-select: none; -webkit-touch-callout: none; -webkit-user-select: none; -khtml-user-select: none; -moz-user-select: none; -ms-user-select: none;
			background: transparent;
			transition: transform 0.8s;
			transform-style: preserve-3d;

			.card-front, .card-back {
				position: absolute;
				top: 0; left: 0;
				display: flex;
				width: 100%; height: 100%;
				padding-top: 30%; padding-bottom: 30%;
				justify-content: center;
				align-items: center;
				border-radius: 0.5rem;
				box-shadow: 0 0 1em rgba(0, 0, 0, 0.2);
				-webkit-backface-visibility: hidden; /* Safari */
				backface-visibility: hidden;
			}

			.card-front {
				transform: rotateY(0deg);
			}

			.card-back {
				transform: rotateY(180deg);

			}

			.word {
				display: block;
				width: 100%;
				padding: 0.8vmin;
				line-height: 2vmin;
				white-space: nowrap;
				color: black;
				background: rgba(255, 255, 255, 1);
				border: 1px solid #313131;
				border-left: 0; border-right: 0;
				overflow: hidden;

				.textFitted {
					display: inline-block;
					width: 100%;
					vertical-align: middle;
					user-select: none; -webkit-touch-callout: none; -webkit-user-select: none; -khtml-user-select: none; -moz-user-select: none; -ms-user-select: none;
				}
			}

			.guess-button {
				position: absolute;
				display: inline-block;
				bottom: 0.1em;
				font-size: 1em;

				&.force-show {
					display: inline-block !important;
				}
			}

			.clue {
				position: absolute;
				display: flex;
				width: 95%;
				bottom: 0;
				padding: 0.5em;
				justify-content: center;
				align-items: center;
				text-align: center;
				font-size: 0.7em;

				.clue-text {
					display: inline-block;
					padding: 0.5em;
					margin: 0 0.25em;
					color: black;
					background: rgba(255,255,255,0.5);
					border-radius: 0.7em;
					white-space: nowrap;
    				overflow: hidden;
					text-overflow: ellipsis;
				}

				.clue-number {
					display: inline-block;
					padding: 0.5em 0.7em;
					margin: 0 0.25em;
					color: black;
					background: rgba(255,255,255,0.5);
					border-radius: 50%;
				}
			}

			:global(.icon) {
				width: 3em;
				height: 3em;
			}
		}

		.selected-by {
			position: absolute; z-index: 1;
			top: -1.2em;
			left: 0.2em; right: 0.2em;
			width: 100%; height: 4em;
			overflow: hidden;
			pointer-events: none; // this stops covering/blocking card above when hovered/expanded

			.selected-by-player {
				display: inline-flex;
				align-items: center;
				justify-content: center;
				width: 2em; height: 2em; min-width: 2em;
				padding: 0.5em;
				margin: 0 0.1em;
				font-size: 0.9em;
				text-align: center;
				border: 1px solid white;
				border-radius: 50%;
				color: white;
				overflow: hidden;

				&.player-team-one {
					background: rgba(30,130,255,1);
				}
				&.player-team-two {
					background: rgba(255,0,204,1);
				}
			}
		}
	}
</style>